
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g0224ICShK3aHoD45kuYW9XLUcTi65buGUf4PrBOcn44Meta } from "/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexE4PTa8X6KwJRk8_458oV4E4cSN3vw_VnxAi5mnI_45aorHgMeta } from "/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchjUOkacim_45D2C0FMuw47P0SYTXc2Yxk_45tyzTRGuVE71QMeta } from "/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexTgxIefghAh_gx1L_454jSX1JktPOySM0iLvv8OP3ZU5EoMeta } from "/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93IpEClqRDTnjaG3y4sauKXQb8W2uhHVaRdadWN5BCvzcMeta } from "/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexNCrzUIUlefApiIUnsZkc_uCelE6YFwmjTDnenDdXBZAMeta } from "/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_936BJK6lWpZlTl_nlGbh7WzBWj8TUHI2VBgzEoVkBzuk8Meta } from "/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexYvAprPmnorzxWZNeyDLd7JALrWugCuyyUHuEbqsqO5MMeta } from "/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93I6SeP7PQjgIpJ_s9gqWkTpCw8EjNiVaD2_qUBaS5ZesMeta } from "/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexIxMH_45hc1A8FHyaRElT533_QfPe1bAQfLBBz6JTBqV0kMeta } from "/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexZ6GH2iX_45_45Sln_45_45LgmtgfCgqiMo1RyBdgTNq4TX4_45XdUMeta } from "/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexNCrzUIUlefApiIUnsZkc_uCelE6YFwmjTDnenDdXBZAMeta || {},
    component: () => import("/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexYvAprPmnorzxWZNeyDLd7JALrWugCuyyUHuEbqsqO5MMeta || {},
    component: () => import("/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexIxMH_45hc1A8FHyaRElT533_QfPe1bAQfLBBz6JTBqV0kMeta || {},
    component: () => import("/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexZ6GH2iX_45_45Sln_45_45LgmtgfCgqiMo1RyBdgTNq4TX4_45XdUMeta || {},
    component: () => import("/codebuild/output/src4044609408/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]